import FormElementSumWithCurrency from '@/components/FormElementSumWithCurrency/FormElementSumWithCurrency';

export type { SumWithCurrency } from '@/components/FormElementSumWithCurrency/FormElementSumWithCurrencyTypes';

export default FormElementSumWithCurrency;
